import { createAction } from '@reduxjs/toolkit';

export const toggleDarkMode = createAction('toggleDarkMode');

export const toggleTheme = isDarkModeEnabled => dispatch => {
    return dispatch(toggleDarkMode(isDarkModeEnabled));
};
